const CHANNEL_NAME = "np-auth";
const LOGOUT_MESSAGE = "logout";
// Fallback for browsers without BroadcastChannel; carries a timestamp only, never a secret.
const FALLBACK_KEY = "authLogoutAt";

const createChannel = () =>
  typeof BroadcastChannel !== "undefined" ? new BroadcastChannel(CHANNEL_NAME) : null;

export const broadcastLogout = () => {
  const channel = createChannel();
  if (channel) {
    channel.postMessage(LOGOUT_MESSAGE);
    channel.close();
    return;
  }
  try {
    localStorage.setItem(FALLBACK_KEY, Date.now().toString());
    localStorage.removeItem(FALLBACK_KEY);
  } catch {
    // storage unavailable; other tabs sign out on their next refresh attempt
  }
};

// Calls `onLogout` when ANOTHER tab signs out. Returns an unsubscribe function.
export const onRemoteLogout = (onLogout: () => void) => {
  const channel = createChannel();
  if (channel) {
    channel.onmessage = event => {
      if (event.data === LOGOUT_MESSAGE) onLogout();
    };
    return () => channel.close();
  }
  const onStorage = (event: StorageEvent) => {
    if (event.key === FALLBACK_KEY && event.newValue) onLogout();
  };
  window.addEventListener("storage", onStorage);
  return () => window.removeEventListener("storage", onStorage);
};
